<template>
  <svg width="100%" height="320px" class="plan-vector-map">
    <g ref="base"></g>
    <g ref="departamentos"></g>
  </svg>
</template>

<script>
  import * as d3 from 'd3'
  import { feature } from 'topojson'
  import { find, map } from 'lodash'

  export default {
    name: "MapaInfluencia",
    props: {
      departamentos: Array
    },
    data() {
      return {
        width: 320,
        height: 320
      }
    },
    mounted() {
      this.renderMapa()
    },
    computed: {
      projection () {
        return d3.geoMercator()
          .translate([this.width/2, this.height/2])
          .scale(1500)
      },
      path () {
        return d3.geoPath().projection(this.projection)
      },
      peru() {
        return require(`../data/mapas/peru.json`)
      }
    },
    methods: {
      renderMapa() {

        let base = d3.select(this.$refs['base'])

        let bounds = d3.geoBounds(this.peru),
            center = d3.geoCentroid(this.peru)

        // Compute the angular distance between bound corners
        let distance = d3.geoDistance(bounds[0], bounds[1]),
            scale = this.width / distance / Math.sqrt(1)

        this.projection
          .translate([this.width/2, this.height/2])
          .center(center)
          .scale(scale)

        base.selectAll('path')
          .data(this.peru.features)
          .enter()
          .append('path')
          .attr('d',this.path)
          .attr('class', dep => {
            return `departamento-path ${dep}-path`
          })
          
          let distritosFeatures = map(this.departamentos, (dep) => {
            
            let features = feature(dep.geodata, dep.geodata.objects[dep.slug])

            let featuresGroup = d3.select(this.$refs['departamentos'])

            featuresGroup.selectAll('path')
              .data(features.features)
              .enter()
              .append('path')
              .attr('d',this.path)
              .attr('class', distrito => {
                if(find(dep.distritos, ['nombre', distrito.properties.DISTRITO])) {
                  return `distrito-path distrito-selected`
                }
                return `distrito-path`
              })
            
            // featuresGroup
            // .selectAll("circle")
            // .data(features.features)
            // .enter()
            // .append("circle")
            // .attr("class", "circle")
            // .attr("transform",(d) => {                 
            //   var p = this.projection(d3.geoCentroid(d))
            //   return "translate("+p+")";
            // })
            // .attr("r", (distrito) => {
            //   if(dep.distritos.includes(distrito.properties.DISTRITO)) {
            //     return 5
            //   }

            //   return 
            // })
            // .attr("stroke-width", 3)
            // .attr("fill-opacity", .4)
          })        
        
        return distritosFeatures
      }
    }
  }

</script>

<style>
  svg.plan-vector-map {
    background: #f1f1f1;
  }
  .distrito-path {
    fill: #91ad8d;
    stroke: #ffffff21;
    stroke-width: 1px;
  }

  .circle {
    fill: #fff;
  }

  .departamento-path {
    fill: #eaeaea;
    stroke: #66755d;
    stroke-width: 1px;
  }

  .distrito-selected {
    fill: #b55353;
  }

  .departamento-map {
    width: 100%;
  }
</style>